import clearExpiredLocales from "./clear-expired-locales.js";
import clearExpiredTokens from "./clear-expired-tokens.js";
import updateMediaStorage from "./update-media-storage.js";
import deleteExpiredMedia from "./delete-expired-media.js";

export default {
	clearExpiredLocales,
	clearExpiredTokens,
	updateMediaStorage,
	deleteExpiredMedia,
};
